import { useMemo, useState } from 'react';
import { Spinner } from '../ui/index';

const HIDDEN_DEPTS = new Set(['dispatcher', 'دستیار هوش مصنوعی']);

function isHiddenDept(name) {
  const n = (name || '').trim();
  return !n || HIDDEN_DEPTS.has(n) || HIDDEN_DEPTS.has(n.toLowerCase());
}

function personLabel(emp) {
  const name = [emp.first_name, emp.last_name].filter(Boolean).join(' ').trim();
  return name || emp.username;
}

export default function OtherDeptParticipantPicker({
  employees = [],
  loading = false,
  myDepartmentName = '',
  myUsername = '',
  addedUsernames = [],
  onAdd,
}) {
  const [open, setOpen] = useState(false);
  const [selectedDept, setSelectedDept] = useState('');

  const departments = useMemo(() => {
    const mine = (myDepartmentName || '').trim();
    const names = new Set();
    employees.forEach((e) => {
      if (e.active === 0 || e.active === false) return;
      const dept = (e.department_name || '').trim();
      if (isHiddenDept(dept) || dept === mine) return;
      names.add(dept);
    });
    return [...names].sort((a, b) => a.localeCompare(b, 'fa'));
  }, [employees, myDepartmentName]);

  const deptEmployees = useMemo(() => {
    if (!selectedDept) return [];
    return employees.filter((e) => {
      if (e.active === 0 || e.active === false) return false;
      if ((e.department_name || '').trim() !== selectedDept) return false;
      if (e.username === myUsername) return false;
      return !!e.username;
    });
  }, [employees, selectedDept, myUsername]);

  return (
    <div>
      <button
        type="button"
        onClick={() => setOpen((v) => !v)}
        style={{
          width: '100%', padding: '9px 12px', borderRadius: 8, border: '1.5px dashed #86efac',
          background: open ? '#f0fdf4' : '#fff', color: '#166534', fontSize: 12, fontWeight: 600,
          fontFamily: 'inherit', cursor: 'pointer', textAlign: 'right',
        }}
      >
        {open ? '▾ بستن انتخاب از دپارتمان‌های دیگر' : '＋ انتخاب از دپارتمان‌های دیگر'}
      </button>

      {open && (
        <div style={{ marginTop: 8, border: '1.5px solid #bbf7d0', borderRadius: 10, padding: 10, background: '#f8fffb' }}>
          {loading ? (
            <div style={{ display: 'flex', justifyContent: 'center', padding: 12 }}><Spinner size={16} /></div>
          ) : departments.length === 0 ? (
            <div style={{ fontSize: 12, color: '#94a3b8' }}>دپارتمان دیگری یافت نشد.</div>
          ) : (
            <>
              <div style={{ fontSize: 11, color: '#64748b', marginBottom: 8 }}>یک دپارتمان را انتخاب کنید</div>
              <div style={{ display: 'flex', flexWrap: 'wrap', gap: 6, marginBottom: 10 }}>
                {departments.map((name) => (
                  <button
                    key={name}
                    type="button"
                    onClick={() => setSelectedDept(name)}
                    style={{
                      padding: '6px 10px', borderRadius: 999, fontSize: 12, fontFamily: 'inherit', cursor: 'pointer',
                      border: selectedDept === name ? '1.5px solid #16a34a' : '1.5px solid #e2e8f0',
                      background: selectedDept === name ? '#dcfce7' : '#fff',
                      color: selectedDept === name ? '#166534' : '#334155',
                      fontWeight: selectedDept === name ? 700 : 500,
                    }}
                  >
                    {name}
                  </button>
                ))}
              </div>
              {selectedDept ? (
                deptEmployees.length === 0 ? (
                  <div style={{ fontSize: 12, color: '#94a3b8' }}>کارمندی در این دپارتمان نیست.</div>
                ) : (
                  <div style={{ display: 'flex', flexDirection: 'column', gap: 4, maxHeight: 180, overflowY: 'auto' }}>
                    {deptEmployees.map((emp) => {
                      const added = addedUsernames.includes(emp.username);
                      return (
                        <button
                          key={emp.username}
                          type="button"
                          disabled={added}
                          onClick={() => onAdd({
                            username: emp.username,
                            department_name: selectedDept,
                            label: personLabel(emp),
                          })}
                          style={{
                            padding: '8px 10px', borderRadius: 8, border: '1px solid #e2e8f0',
                            background: added ? '#f8fafc' : '#fff', textAlign: 'right', cursor: added ? 'default' : 'pointer',
                            fontFamily: 'inherit', fontSize: 12, color: added ? '#94a3b8' : '#334155',
                            display: 'flex', justifyContent: 'space-between', alignItems: 'center',
                          }}
                        >
                          <span>
                            {personLabel(emp)}
                            <span style={{ color: '#94a3b8', marginRight: 6 }}>({emp.username})</span>
                          </span>
                          <span style={{ color: added ? '#86efac' : '#16a34a', fontWeight: 700 }}>
                            {added ? 'اضافه شده' : 'افزودن'}
                          </span>
                        </button>
                      );
                    })}
                  </div>
                )
              ) : null}
            </>
          )}
        </div>
      )}
    </div>
  );
}
